import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import Dialog from '@mui/material/Dialog';

import classes from './DialogWrapper.scss';

export default class DialogWrapper extends PureComponent {
  static propTypes = {
    open        : PropTypes.bool,
    className   : PropTypes.string,
    style       : PropTypes.object,
    overlayStyle: PropTypes.object,
  }

  render() {
    const { children, style, overlayStyle, className, isMobile, ...rest } = this.props;

    return (
      <Dialog
        {...rest}
        fullWidth={true}
        classes={{
          ...rest.classes,
          paperFullScreen: classes.paperFullScreen,
          paperScrollBody: classes.paperScrollBody
        }}
      >
        {children}
      </Dialog>
    )
  }
}
